import { APIService } from '../services/index'

const initState = {
    loading: false,
    textProcess: 'In processo...',
    date: null,
    speseMensile: [],
    speseNonProtocollate: [],
}

const pageStore = {
    state: initState,
    namespaced: true,
    getters: {
        loading(state) {
            return state.loading
        },
        textProcess(state) {
            return state.textProcess
        },
        mensile(state) {
            return state.speseMensile
        },
        nonProtocollate(state) {
            return state.speseNonProtocollate
        },
    },
    mutations: {
        SET_REPORT_MENSILE(state, payload) {
            state.speseMensile = payload;
        },
        SET_REPORT_NON_PROTOCOL(state, payload) {
            state.speseNonProtocollate = payload;
        },
        SET_LOADING(state, payload) {
            state.loading = payload.state;
            state.textProcess = payload.text || initState.textProcess;
        },
        SET_DATE(state, payload) {
            state.date = payload
        },
    },
    actions: {
        getMensile(context, params) {
            context.commit('SET_LOADING', {state: true, text: 'Estrazione...'});
            APIService.reportGetMensile(params)
                    .then(function (res) {
                        context.commit('SET_REPORT_MENSILE', res.data)
                        context.commit('SET_LOADING', {state: false});
                    })
        },
        checkNonProtocollate(context, params) {
            context.commit('SET_LOADING', {state: true, text: 'Verifica...'});
            APIService.reportCheckNonProtocollate(params)
                    .then(function (res) {
                        context.commit('SET_REPORT_NON_PROTOCOL', res.data)
                        context.commit('SET_LOADING', {state: false});
                    })
        },
        beforeProtocollaSpesa(context, params) {
            let $that = this._vm;
            context.commit('SET_LOADING', {state: true, text: 'Verifica le note della spesa...'});
            return APIService.beforeReportProtocollaSpesa(params)
                    .then(function (res) {
                        context.commit('SET_LOADING', {state: false});
                        if (res.textError)
                            $that.$notify({
                                group: res.stato,
                                text: res.textError
                              });
                        return res
                    })
        },
        getProtocolloSpesa(context, params) {
            let $that = this._vm;
            context.commit('SET_LOADING', {state: true, text: 'Generazione PDF...'});
            return APIService.reportProtocollaSpesa(params)
                    .then(function (res) {
                        context.commit('SET_LOADING', {state: false});
                        if (res.textError)
                            $that.$notify({
                                group: res.stato,
                                text: res.textError
                              });
                    
                        context.dispatch('getMensile', { data: context.state.date });
                        return res
                    })
        },
        protocollaSpesa(context, params) {
            let $that = this._vm;
            context.commit('SET_LOADING', {state: true, text: 'Stap rotocollando...'});
            return APIService.confermaProtocolloSpesa(params)
                    .then(function (res) {
                        context.commit('SET_LOADING', {state: false});
                        if (res.textError)
                            $that.$notify({
                                group: res.stato,
                                text: res.textError
                              });
                    
                        context.dispatch('getMensile', { data: context.state.date });
                        return res
                    })
        },
    }
};

export default pageStore;


// WEBPACK FOOTER //
// ./modules/Home/views/src/stores/report.js